import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class GlobalService {
	private featureFlags: any;

	constructor(private _http: HttpClient) {
	}

	/**
	 * @api {get} /v2/Global/Profile/AnonymousOptions Get Anonymous Global Options
	 * @apiName getAnonymousGlobalOptions
	 * @apiGroup Global
	 * @apiVersion 20.0.0
	 */
	getAnonymousGlobalOptions() {
		return this._http.get<any>(`${environment.apiUrl}/v2/Global/Profile/AnonymousOptions`);
	}

	/**
	 * @api {get} /v3/BroadcastMessages Get Broadcast Message
	 * @apiName getBroadcastMessage
	 * @apiParam {string} [messageType] Message Type i.e, rapidship
	 * @apiGroup BroadcastMessages
	 * @apiVersion 23.0.0
	 */
	getBroadcastMessage() {
		let params: HttpParams = new HttpParams();
		params = params.append('messageType', 'rapidship');
		return this._http.get<any>(`${environment.apiUrl}/v3/BroadcastMessages`, {params});
	}

	/**
	 * @api {get} /v2/Global/Orders/Options Get Global Options
	 * @apiName getGlobalOptions
	 * @apiGroup Global
	 * @apiVersion 20.0.0
	 */
	getGlobalOptions() {
		return this._http.get<any>(`${environment.apiUrl}/v2/Global/Orders/Options`);
	}

	/**
	 * @api {get} /v2/Global/Permissions/LicenseKey Get Licenses
	 * @apiName getLicenses
	 * @apiGroup Global
	 * @apiVersion 20.0.0
	 */
	getLicenses() {
		return this._http.get<any>(`${environment.apiUrl}/v2/Global/Permissions/LicenseKey`);
	}

	/**
	 * @api {get} /v3/FeatureFlags Get Feature Flags
	 * @apiName getFeatureFlags
	 * @apiGroup XdUsers
	 * @apiVersion 20.0.0
	 */
	getFeatureFlags() {
		return new Observable((observer) => {
			if (!this.featureFlags) {
				this._http.get<any>(`${environment.apiUrl}/v3/FeatureFlags`).subscribe({
					next: (featureFlags) => {
						this.featureFlags = featureFlags;
						observer.next(this.featureFlags);
						observer.complete();
					}, error: (error) => {
						observer.next({});
						observer.complete();
					}
				});
			} else {
				observer.next(this.featureFlags);
				observer.complete();
			}
		});
	}
}
